import { McpServers } from "../McpServers";
import Section from "./Section";

import type { ConfigSection } from "../ConfigSectionHelp";
import type { Agent } from "@/shared/types";

export default function McpSection({ agent, onUpdateAgent, onHelp }: {
  agent: Agent;
  onUpdateAgent: (updater: (a: Agent) => Agent) => void;
  onHelp: (section: ConfigSection) => void;
}) {
  const enabled = !!agent.capabilities?.mcpEnabled;
  const toggle = () => onUpdateAgent((a) => ({ ...a, capabilities: { ...a.capabilities, mcpEnabled: !enabled } }));
  return (
    <Section section="mcp" onHelp={onHelp} enabled={enabled} onToggle={toggle}>
      <McpServers agentId={agent.id} />
    </Section>
  );
}
